module.exports = __webpack_public_path__ + "img/loadingSpinner.3f259006.gif";